export default function AppFooter() {

    return (
        <div className="App-footer">
            <a href="https://www.silubi.com">silubi.com</a>&nbsp;&nbsp;
            <span className="blue-text">|</span>&nbsp;&nbsp;
            <a href="https://www.silubi.io">silubi.io</a>
        </div>
    );
}